const validate = (values) => {
  const attrs = values || {};
  const errors = {};
  if (!attrs.usuario || !attrs.usuario.value) {
    errors.usuario = 'Debe seleccionar el alumno';
  }
  if (!attrs.malla || !attrs.malla.value) {
    errors.malla = 'Debe seleccionar la malla';
  }
  if (!(attrs.numeroLegajo && attrs.numeroLegajo > 0)) {
    errors.numeroLegajo = 'El número de legajo no es correcto';
  }

  if (!attrs.fechaIngreso) {
    errors.fechaIngreso = 'Debe ingresar la fecha de ingreso';
  }

  return errors;
};

export default validate;
